import React, { useState } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import "./WhatsAppIcon.css";
import logo from "../static/media/logo.webp";

const WhatsAppIcon = () => {
  const [isOpen, setIsOpen] = useState(false);

  const whatsappMessage = encodeURIComponent(
    "Hola, quiero agendar una cita."
  );

  const whatsappLink = `https://wa.me/593984781610?text=${whatsappMessage}`;

  return (
    <>
      <div className={`whatsapp-popup ${isOpen ? "open" : ""}`}>
        <div className="popup-header">
          <div className="popup-header-content">
            <p className="popup-title">Estamos para ayudarte</p>
            <p className="popup-message">Escríbenos y agenda tu cita.</p>
          </div>

          <button
            className="popup-close"
            onClick={() => setIsOpen(false)}
            aria-label="Cerrar ventana de WhatsApp"
          >
            <FaTimes aria-hidden="true" />
          </button>
        </div>

        <div className="popup-body">
          <a
            href={whatsappLink}
            className="popup-contact"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Agendar cita por WhatsApp"
          >
            <img src={logo} alt="Lily´s Sunflowers" className="popup-logo" />

            <div className="popup-contact-info">
              <p className="popup-contact-title">Agendar por WhatsApp</p>
              <p className="popup-contact-subtitle">Respuesta rápida</p>
            </div>
          </a>
        </div>
      </div>

      <button
        className="whatsapp-icon"
        onClick={() => setIsOpen(true)}
        aria-label="Abrir chat de WhatsApp"
      >
        <FaWhatsapp aria-hidden="true" />
      </button>
    </>
  );
};

export default WhatsAppIcon;